function getResponseElements(form) {
	return {
		error: form.querySelector('#mce-error-response'),
		feedback: form.querySelector('.footer-signup-feedback'),
		processing: form.querySelector('.footer-signup-processing'),
		row: form.querySelector('.footer-signup-form-row'),
		success: form.querySelector('#mce-success-response'),
	};
}

function resetResponses(form) {
	const responses = getResponseElements(form);

	[responses.error, responses.success].forEach(function (response) {
		if (!response) {
			return;
		}

		response.textContent = '';
		response.hidden = true;
	});

	if (responses.feedback) {
		responses.feedback.hidden = true;
		responses.feedback.classList.remove('is-error', 'is-processing', 'is-success');
	}

	if (responses.processing) {
		responses.processing.hidden = true;
	}

	if (responses.row) {
		responses.row.hidden = false;
	}
}

function getResponseText(message) {
	const parser = new window.DOMParser();
	const parsedMessage = parser.parseFromString(String(message || ''), 'text/html');

	return parsedMessage.body.textContent.trim().replace(/^\d+\s*-\s*/, '');
}

function showProcessing(form) {
	const responses = getResponseElements(form);
	const processingText = form.querySelector('.footer-signup-processing-text');

	resetResponses(form);

	if (responses.row) {
		responses.row.hidden = true;
	}

	if (responses.feedback) {
		responses.feedback.hidden = false;
		responses.feedback.classList.add('is-processing');
	}

	if (responses.processing) {
		responses.processing.hidden = false;
	}

	if (processingText) {
		processingText.textContent = form.dataset.processingMessage || 'Submitting...';
	}
}

function showResponse(form, result) {
	const responses = getResponseElements(form);
	const responseType = result.result === 'success' ? 'success' : 'error';
	const response = responses[responseType];
	const fallbackMessage =
		responseType === 'success'
			? 'Thank you for subscribing.'
			: 'The signup request failed. Please try again.';

	if (!response) {
		return;
	}

	resetResponses(form);

	if (responses.row) {
		responses.row.hidden = true;
	}

	if (responses.feedback) {
		responses.feedback.hidden = false;
		responses.feedback.classList.add(`is-${responseType}`);
	}

	response.textContent = getResponseText(result.msg) || fallbackMessage;
	response.hidden = false;
}

function buildRequestUrl(form, callbackName) {
	const url = new URL(form.dataset.mailchimpAjaxUrl);
	const formData = new FormData(form);

	formData.forEach(function (value, key) {
		url.searchParams.append(key, value);
	});

	url.searchParams.set('c', callbackName);

	return url.toString();
}

function submitMailchimpForm(form, submitButton) {
	const callbackName = `pacecoreMailchimp${Date.now()}${Math.random()
		.toString(36)
		.slice(2)}`;
	const script = document.createElement('script');
	let timeoutId;

	function cleanup() {
		window.clearTimeout(timeoutId);
		delete window[callbackName];
		script.remove();

		if (submitButton) {
			submitButton.disabled = false;
			submitButton.removeAttribute('aria-disabled');
		}

		form.removeAttribute('aria-busy');
	}

	window[callbackName] = function (result) {
		cleanup();
		showResponse(form, result || {});

		if (result?.result === 'success') {
			form.reset();
		}
	};

	timeoutId = window.setTimeout(function () {
		cleanup();
		showResponse(form, {
			result: 'error',
			msg: 'The signup request timed out. Please try again.',
		});
	}, 10000);

	script.src = buildRequestUrl(form, callbackName);
	script.onerror = function () {
		cleanup();
		showResponse(form, {
			result: 'error',
			msg: 'The signup request failed. Please try again.',
		});
	};

	document.body.appendChild(script);
}

export function initFooterSignupForm() {
	const form = document.querySelector('.footer-signup-form[data-mailchimp-ajax-url]');

	if (!form) {
		return;
	}

	form.addEventListener('submit', function (event) {
		const submitButton = form.querySelector('[type="submit"]');

		event.preventDefault();

		if (form.getAttribute('aria-busy') === 'true') {
			return;
		}

		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}

		form.setAttribute('aria-busy', 'true');
		showProcessing(form);

		if (submitButton) {
			submitButton.disabled = true;
			submitButton.setAttribute('aria-disabled', 'true');
		}

		submitMailchimpForm(form, submitButton);
	});
}
